// Styles for CustomSelectBlock  go here.
import styled from 'styled-components';

export const StyledCustomSelectBlock = styled.div`
  display: flex;
  .custom-drop-styles {
    align-items: baseline;
  }
`;
